"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttribute = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var AttributeFilterUtils_1 = require("../../utils/AttributeFilterUtils");
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
/**
 * Fetches the attribute related to the Attribute Filter needed to acquire attribute title.
 */
exports.useAttribute = function (context) {
    var filterObjRef = react_1.useMemo(function () { return AttributeFilterUtils_1.getObjRef(context.filter, context.identifier); }, [context.filter, context.identifier]);
    return sdk_ui_1.useCancelablePromise({
        promise: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var attributes, displayForm;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attributes = context.backend.workspace(context.workspace).attributes();
                        return [4 /*yield*/, attributes.getAttributeDisplayForm(filterObjRef)];
                    case 1:
                        displayForm = _a.sent();
                        return [2 /*return*/, attributes.getAttribute(displayForm.attribute)];
                }
            });
        }); },
    }, [json_stable_stringify_1.default(filterObjRef), context.workspace, context.backend, context.identifier]);
};
//# sourceMappingURL=useAttribute.js.map